var React = require('react');

function ArrowL (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M65.28,166.48a7.33,7.33,0,0,0,10,1,7,7,0,0,0,1-9.87l-1-1L24.18,106.28h169a7,7,0,0,0,0-14h-169L75.5,41.94a7.2,7.2,0,0,0,0-9.87,7.1,7.1,0,0,0-10,0L2.13,94.44a6.77,6.77,0,0,0-.2,9.67l.2.2Z","transform":"translate(0 -30)"}));
}

ArrowL.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 200 139"};

module.exports = ArrowL;

ArrowL.default = ArrowL;
